/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import {
  ButtonGroup,
  CircularProgress,
  IconButton,
  Paper,
  TableContainer,
  Tooltip,
  Typography,
} from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import VisibilityIcon from "@mui/icons-material/Visibility";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import {
  useFilters,
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import {
  handleDeletePerClose,
  handleDeletePerOpen,
  handleEditOpen,
  handleViewOpen,
  rowValue,
  rowValue1,
} from "../../../redux/Reducer/ModalSlice";
import TableFilter from "../../table-components/filter/TableFilter";
import TableComp from "../../table-components/table/TableComp";
import EditIcon from "@mui/icons-material/Edit";
import Pagination from "../../table-components/pagination/Pagination";
import AddModal from "../../modal/AddModal";
import EditModal from "../../modal/EditModal";

import {
  ActiveStatus,
  InactiveStatus,
  StatusContainer,
} from "../../Dashboard/Dashboard.style";
import AddThana from "./AddThana";

import EditThana from "./EditThana";
import ViewModal from "../../modal/ViewModal";
import DeleteModal from "../../modal/DeleteModal";
import {
  DeleteCancelButton,
  DeleteOkButton,
  DeletePermission,
  DeletePermissionText,
} from "../../Volunteer/Volunteer.style";
import { toast } from "react-toastify";
import useProfile from "../../../hooks/useProfile";
import ThanaView from "./ThanaView";
const ThanaSetup = () => {
  const dispatch = useDispatch();
  const [thanaInfoData, setThanaInfoData] = useState({});
  const [upazilaId,setUpazilaId] = useState();
  const [userData] = useProfile();
  const {
    refetch,
    isLoading,
    data: thanaInfo = [],
  } = useQuery({
    queryKey: ["thanaInfo"],
    queryFn: async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/getThanaList`
      );
      const data = await res.json();
      return data;
    },
  });

  function handleEdit(rowData) {
    dispatch(handleEditOpen());
    dispatch(rowValue(rowData));

 
  }
  function handleView(rowData) {
    dispatch(handleViewOpen());
    dispatch(rowValue(rowData));
    // dispatch(rowV  alue1("1"));

  }
  const DeleteMethod = (rowData) => { 
    dispatch(handleDeletePerOpen());
    const upazilaId = rowData.upazila_id; 
    setThanaInfoData(rowData);
    
    setUpazilaId(upazilaId)
    
  };
  

  const columns = React.useMemo(
    () => [
      {
        Header: "District",
        accessor: "dzila_name",
        Filter: false,
      },
      {
        Header: "Police Station",
        accessor: "thana_name",
        Filter: false,
      },
      {
        Header: "Thana Code",
        accessor: "thana_code",
        Filter: false,
      },
      {
        Header: "Active Status",
        accessor: "astatus_fg",
        Filter: false,
        Cell: (thanaInfo) => (
          <div
            style={{
              marginLeft: "10Px",
            }}
          >
            {thanaInfo.value === 1 ? (
              <StatusContainer>
                <ActiveStatus>Active</ActiveStatus>
              </StatusContainer>
            ) : (
              <StatusContainer>
                <InactiveStatus>Inactive</InactiveStatus>
              </StatusContainer>
            )}
          </div>
        ),
      },

      {
        Header: "Action",
        accessor: "col5",
        Cell: (row) => (
          <ButtonGroup
            style={{
              marginLeft: "10Px",
            }}
          >
            
            {(userData.ugleve_name === "Admin" ||
              userData.ugleve_name === "Developer") && (
            <IconButton
              size="small"
              sx={{ "&:hover": { color: "#2e68e8" } }}
              style={{ color: "#2196F3" }}
              variant="none"
              onClick={() => handleEdit(row.row.original)}
            >
              <Tooltip title="Update">
                <EditIcon sx={{ fontSize: 18 }} />
              </Tooltip>
            </IconButton>
              )}
            <IconButton
              size="small"
              sx={{ "&:hover": { color: "#2e68e8" } }}
              style={{ color: "#189A2E" }}
              variant="none"
              onClick={() => handleView(row.row.original)}
            >
              <Tooltip title="Details">
                <VisibilityIcon
                  sx={{ fontSize: 18 }}
                  // fontSize="small"
                />
              </Tooltip>
            </IconButton>

        
              <IconButton
                size="small"
                sx={{
                  color: " red",
                }}
                onClick={() => DeleteMethod(row.row.original)} 
              >
                <HighlightOffIcon />
              </IconButton>
       
          </ButtonGroup>
        ),
        Filter: false,
        disableSortBy: true,
      },
    ],
    []
  );
  const add = useSelector((state) => state.Modal.add);
  const edit = useSelector((state) => state.Modal.edit);
  useEffect(() => {
    if (!add) {
      refetch();
    }
  }, [add]);

  useEffect(() => {
    if (!edit) {
      refetch();
    }
  }, [edit]);


  const DeleteMethodPer = () => {
    fetch(
      `${process.env.REACT_APP_API_URL}/api/deleteThana/${upazilaId}`,
      {
        method: "GET",
      }
    )
      .then((res) => {
        if (!res.ok) {
          throw new Error("Failed to delete Thana");
        }
        
        const contentType = res.headers.get("content-type");
        if (!contentType || !contentType.includes("application/json")) {
          return "Delete Success";
        }
        return res.json();
      })
      .then((data) => {
        if (data === "Delete Success" || data.success === true) {
          toast.success("Thana Delete successful!.", {
            position: toast.POSITION.TOP_CENTER,
          });
          refetch()
        } else {
          toast.error("Thana not Delete try again !", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
      dispatch(handleDeletePerClose());
  };
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canPreviousPage,
    canNextPage,
    prepareRow,
    gotoPage,
    pageCount,
    setPageSize,
    state,
    setGlobalFilter,
  } = useTable(
    { columns, data: thanaInfo },
    useGlobalFilter,
    useFilters,
    useSortBy,
    usePagination
  );

  const { globalFilter } = state;
  const { pageIndex, pageSize } = state;
  return (
    <>
      <div>
        <TableFilter
          filter={globalFilter}
          setFilter={setGlobalFilter}
          ButtonName="Add Thana"
        />
      </div>
      <TableContainer component={Paper}>
        <TableComp
          getTableProps={getTableProps}
          headerGroups={headerGroups}
          getTableBodyProps={getTableBodyProps}
          page={page}
          prepareRow={prepareRow}
          pageIndex={pageIndex}
        />
        {isLoading && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "280px",
            }}
          >
            <CircularProgress />
          </div>
        )}
        <Pagination
          page={page}
          pageIndex={pageIndex}
          gotoPage={gotoPage}
          canPreviousPage={canPreviousPage}
          previousPage={previousPage}
          nextPage={nextPage}
          canNextPage={canNextPage}
          pageCount={pageCount}
        />
      </TableContainer>
      <AddModal ModalWidth="sm" ModalTitle="Add Thana Information">
        <AddThana />
      </AddModal>

      <EditModal ModalWidth="sm" ModalTitle="Edit Thana Information">
        <EditThana />
      </EditModal>
      <ViewModal ModalWidth="md" ModalTitle="Thana Details">
        <ThanaView></ThanaView>
      </ViewModal>
      <DeleteModal Width="sm" ModalTitle="Thana Delete Permission">
        <DeletePermission>
          <DeletePermissionText>Do you Want Delete?</DeletePermissionText>
          <Typography
            variant="h6"
            gutterBottom
            style={{ color: "red", marginBottom: "20px" }}
          >
            (Note: Deletion history will be recorded.)
          </Typography>
          <DeleteCancelButton
            onClick={() => {
              dispatch(handleDeletePerClose());
            }}
          >
            Cancel{" "}
          </DeleteCancelButton>
          <DeleteOkButton onClick={() => DeleteMethodPer()}>OK</DeleteOkButton>
        </DeletePermission>
      </DeleteModal>
    </>
  );
};
export default ThanaSetup;
